/* eslint-disable */
/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 *
 * this script used to inject menu, popups to be more forgiving
 * created by Tamer Zorba
 */

import isMobile from "ismobilejs";

const isTouch = () => isMobile().tablet || isMobile().phone;

type Element = HTMLElement & {
    openCallback: any;
    closeCallback: any;
};

let preventOpen = false;

/**
 * Header Popups
 * this handler make more forgiving popups with timeouts
 */
export const menu: any = {
    opened: false,
    openTimeout: null,
    closeTimeout: null,
    bindClose: () => {},
    openTime: isTouch() ? 0 : 300,
    closeTime: isTouch() ? 100 : 500,

    open: (elm: Element) => {
        if (preventOpen) return;
        elm.classList.add("active");
        menu.opened = true;
        menu.bindClose = () => menu.close(elm);

        if ((window as any).closeSearchAutocomplete) {
            (window as any).closeSearchAutocomplete();
        }

        elm?.openCallback && setTimeout(elm.openCallback, 10, elm);
        elm.querySelector(":scope > :first-child")?.classList?.add("active");
    },
    close: (elm: Element) => {
        preventOpen = true;
        const hasAnyActiveElm = elm.contains(document.activeElement);
        if (hasAnyActiveElm && document?.activeElement?.nodeName === "INPUT") return;
        preventOpen = false;

        elm.classList.remove("active");
        menu.opened = false;
        clearTimeout(menu.closeTimeout);

        elm.closeCallback && setTimeout(elm.closeCallback, 10, elm);
        elm.querySelector(":scope > :first-child")?.classList?.remove("active");
        document.querySelector("body")?.classList?.remove("shade");
    },
    registerOpen: (elm: Element, callback: any = false) => {
        clearTimeout(menu.openTimeout);
        if (callback) {
            elm.openCallback = callback;
        }
        if (menu.opened) {
            clearTimeout(menu.closeTimeout);

            if (elm.classList.contains("active")) {
                return;
            }

            // const parents = [];
            // let element = elm;
            // // eslint-disable-next-line no-cond-assign
            // while ((element = <Element>element.parentElement)) {
            //     if (element.matches(".active")) {
            //         parents.push(element);
            //     }
            // }

            // const hasActiveParent = parents.length;

            // if (!hasActiveParent) {
            menu.bindClose();
            // }

            menu.open(elm);
            return;
        }

        menu.openTimeout = setTimeout(() => {
            menu.open(elm);
        }, menu.openTime);
    },
    registerClose: (elm?: Element, callback?: any, timeout: number = menu.closeTime) => {
        if (elm && callback) {
            elm.closeCallback = callback;
        }
        clearTimeout(menu.openTimeout);
        clearTimeout(menu.closeTimeout);
        if (!elm || elm.classList.contains("active")) {
            menu.closeTimeout = setTimeout(() => {
                menu.bindClose();
            }, timeout);
        }
    },
    closeAll: (timeout = 20) => {
        menu.registerClose(undefined, undefined, timeout);
    },
};

if (typeof document !== "undefined") {
    document?.addEventListener(
        "click",
        e => {
            if (!menu.opened) return;

            let element = <Element>e.target;

            if (element.classList.contains("close-menu") || element.parentElement?.classList.contains("close-menu")) {
                setTimeout(() => {
                    menu.closeAll();
                }, 100);
                return;
            }

            const parents = [];
            while ((element = <Element>element.parentElement)) {
                if (element.matches(".active")) {
                    parents.push(element);
                }
            }

            const hasActiveParent = parents.length;

            if (!hasActiveParent) {
                menu.closeAll();
            }
        },
        true,
    );
}

export default menu;
